// Libs
import Translation from 'libs/Translation';

// Components
import Text from 'components/common/Text';

const Services = ({ doctor }) => {

    return (
        <div className="box">
            <Text 
                tag="h2"
                color="#0D2439"
                className="title"
            >
                {Translation.t('title.services')}
            </Text>
            <div className='list'>
            {doctor.Services.map(service => 
                <div 
                    key={service}
                    className='row-flex gap-8-center'
                >
                    <div className='filled-circle' />
                    <Text 
                        tag="h3"
                        color="#61788E"
                        className="item margin-1"
                    >
                        {service}
                    </Text>
                </div>
                 )}
            </div>
        </div>
    )
}
export default Services;